import { GET_TRACKER_SETTINGS } from '@@/graphQL/web'
import { initializeTracker } from '@@/website/utils/trackerLoader'
import { setTrackerCustomerSystemId, trackPageView } from '@@/website/utils/tracker'

export default ({ app, store }) => {
  let trackerLoadSubscribed = false

  const trackPageOpening = () => {
    if (store.state.user?.authenticated) {
      setTrackerCustomerSystemId(store.state.user.externalId)
    }

    trackPageView()
  }

  const subscribeToTrackerLoad = () => {
    const api = window.ocapi

    if (!trackerLoadSubscribed && api && typeof api.on === 'function') {
      api.on('load', trackPageOpening)
      trackerLoadSubscribed = true
    }
  }

  // Не затираем пользовательскую функцию, если она была объявлена во "вставке кода"
  const previousOnOcapiReady = window.onOcapiReady

  window.onOcapiReady = function () {
    subscribeToTrackerLoad()

    if (typeof previousOnOcapiReady === 'function') {
      previousOnOcapiReady.apply(this, arguments)
    }
  }

  app.router?.afterEach(trackPageOpening)

  const apollo = app.apolloProvider?.defaultClient

  if (!apollo) {
    return
  }

  apollo.query({
    query: GET_TRACKER_SETTINGS,
    variables: { siteCode: store.state.siteCode }
  }).then(({ data }) => {
    initializeTracker(data?.trackerSettings)
  }).catch(() => {})
}
